import React from 'react'

interface SystemMessageProps {
  content: string
}

/**
 * Component for rendering system messages (confirmations, errors, etc.)
 * Displays in a centered, amber-colored container.
 */
export function SystemMessage({ content }: SystemMessageProps) {
  return (
    <div className='flex justify-center'>
      <div className='rounded-lg bg-amber-50/80 px-3 py-1 dark:bg-amber-950/20'>
        <p className='text-xs text-amber-700 dark:text-amber-400'>
          {content}
        </p>
      </div>
    </div>
  )
}